<template>
  <div style="padding-top: 3px;">
    <div
      v-if="showProgress(message)"
      style="text-align: right; padding-right: 2px;"
    >
      <v-progress-linear :value="message.deliver.progress"></v-progress-linear>
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon
            v-on="on"
            v-on:click="cancelDeliverFile(message.deliver.id, sessionId)"
            color="red"
            >mdi-close-circle-outline</v-icon
          >
        </template>
        <span>cancel</span>
      </v-tooltip>
    </div>
    <div v-else-if="showRuning(message)">
      <v-progress-linear indeterminate></v-progress-linear>
    </div>
    <div
      v-if="showFailed(message)"
      style="text-align: right; padding-right: 2px;"
    >
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon
            v-on="on"
            v-on:click="resendFile(message.deliver.id, sessionId)"
            >mdi-replay</v-icon
          >
        </template>
        <span>resend</span>
      </v-tooltip>
      &nbsp;&nbsp;
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon
            v-on="on"
            v-on:click="removeMessage(message.deliver.id, sessionId)"
            >mdi-delete</v-icon
          >
        </template>
        <span>delete</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import Const from '@/utils/const'
import { mapActions } from 'vuex'
export default {
  name: 'DeliverReaction',
  props: {
    message: Object,
    sessionId: String
  },
  methods: {
    ...mapActions('agent', ['removeMessageByDeliverId']),
    showFailed(message) {
      return (
        message.deliver &&
        message.deliver.status == Const.MessageDeliverStatus.FAILED
      )
    },
    showProgress(message) {
      return (
        message.deliver &&
        message.deliver.status == Const.MessageDeliverStatus.UPLOADING_FILE &&
        message.deliver.progress <= 100
      )
    },
    showRuning(message) {
      return (
        message.deliver &&
        message.deliver.status == Const.MessageDeliverStatus.SENDING
      )
    },
    resendFile(deliverId, sessionId) {
      this.$emit('onResendFile', { deliverId, sessionId })
    },
    removeMessage(deliverId, sessionId) {
      this.removeMessageByDeliverId({ sessionId, deliverId })
    },
    cancelDeliverFile(deliverId, sessionId) {
      this.$emit('onCancelDeliverFile', { deliverId, sessionId })
    }
  }
}
</script>
